var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 7.33333C10.3333 6.04467 9.28866 5 7.99999 5C6.71132 5 5.66666 6.04467 5.66666 7.33333C5.66666 8.622 6.71132 9.66667 7.99999 9.66667C9.28866 9.66667 10.3333 8.622 10.3333 7.33333Z",
    stroke: "#006838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3218 7.5666C10.5365 7.63167 10.7641 7.66667 11 7.66667C12.2887 7.66667 13.3333 6.622 13.3333 5.33333C13.3333 4.04467 12.2887 3 11 3C9.79006 3 8.79519 3.92093 8.67819 5.10009",
    stroke: "#006838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.32179 5.10009C7.20479 3.92093 6.20994 3 4.99999 3C3.71132 3 2.66666 4.04467 2.66666 5.33333C2.66666 6.622 3.71132 7.66667 4.99999 7.66667C5.23586 7.66667 5.46356 7.63167 5.67817 7.5666",
    stroke: "#006838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 11C14.6667 9.15903 13.0251 7.66663 11 7.66663",
    stroke: "#006838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 13C11.6667 11.159 10.0251 9.66663 8.00001 9.66663C5.97496 9.66663 4.33334 11.159 4.33334 13",
    stroke: "#006838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00001 7.66663C2.97496 7.66663 1.33334 9.15903 1.33334 11",
    stroke: "#006838",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIcon);
export default __webpack_public_path__ + "static/media/MemberIcon.2d34b3b2d8362a193bfc316b1a33a260.svg";
export { ForwardRef as ReactComponent };